export default __webpack_public_path__ + "static/media/black_swirl.c53f3ad0.png";